/**
 * Catalog Routes
 */

import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { CatalogBrowsePage } from "./pages/catalog-browse";
import { ProductComparisonPage } from "./pages/product-comparison";
import { ProductDetailPage } from "./pages/product-detail";

export const catalogRoutes: RouteObject[] = [
	{
		path: "/catalog",
		element: (
			<ProtectedRoute requireUserType>
				<CatalogBrowsePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/catalog/compare",
		element: (
			<ProtectedRoute requireUserType>
				<ProductComparisonPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/catalog/:id",
		element: (
			<ProtectedRoute requireUserType>
				<ProductDetailPage />
			</ProtectedRoute>
		),
	},
];
